import { GoogleMapWithContextTypes } from 'ui-components/google-map-with-context/types/google-map-with-context-types';

export const initialMapState: GoogleMapWithContextTypes = {
    map: undefined,
    setMap: (map: google.maps.Map) => {},
};
